"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentTheme = void 0;
var alerts_1 = require("./alerts");
var avatar_1 = require("./avatar");
var buttons_1 = require("./buttons");
var lists_1 = require("./lists");
var steppers_1 = require("./steppers");
var text_inputs_1 = require("./text-inputs");
var typograhpy_1 = require("./typograhpy");
exports.componentTheme = {
    MuiAlert: alerts_1.muiAlertStyles,
    MuiButtonBase: buttons_1.muiBaseButtonStyles,
    MuiFormControl: text_inputs_1.muiFormControlStyles,
    MuiList: lists_1.muiListStyles,
    MuiStep: steppers_1.muiStepperStyles,
    MuiTypography: typograhpy_1.muiTypograpy,
    MuiAvatar: avatar_1.muiAvatarStyles,
};
//# sourceMappingURL=index.js.map